// extracted by mini-css-extract-plugin
module.exports = {"container":"Interstitial-styles-module--container--3EIZC","card":"Interstitial-styles-module--card--yjeer"};